import { getLocalValue, getSessionValue, saveLocalValue, saveSessionValue } from "../Logic/storage";
import { iAuth, iTenant, selectedTenant, iTenants, iTenantsResponse } from "./types";
import { Buffer } from "buffer";

export const awsConfig = {
    ClientId: "",
    Url: "",
    RedirectUrl: "",
};

export async function getTenants(): Promise<iTenantsResponse> {
    const crypto = getLocalValue<iAuth>("auth");
    const hHeaders = new Headers();
    hHeaders.append("Accept", "application/json");
    hHeaders.append("Authorization", "Bearer " + crypto?.token.id_token);
    let fetchOptions: any = {};
    fetchOptions.method = "GET";
    fetchOptions.headers = hHeaders;
    let response = await fetch(getSTSUrl() + "Tenants", fetchOptions);
    let tenantResponse: iTenantsResponse = {} as iTenantsResponse;
    if (response.status == 401) {
        clearSession();
    } else {
        tenantResponse = await response.json();
    }
    tenantResponse.tenants.sort((a, b) => a.name.localeCompare(b.name));
    return tenantResponse;
}

export async function getTenantAuth(tenant: string): Promise<selectedTenant> {
    const crypto = getLocalValue<iAuth>("auth");
    const hHeaders = new Headers();
    hHeaders.append("Accept", "application/json");
    hHeaders.append("Authorization", "Bearer " + crypto?.token.id_token);
    var fetchOptions: any = {};
    fetchOptions.method = "GET";
    fetchOptions.headers = hHeaders;
    const response = await fetch(getSTSUrl() + "Tenants/" + tenant + "/Token?elevate=true", fetchOptions);
    if (response.status == 403) {
        throw new Error("403"); //cant access tenant so refresh the tokens
    } else if (response.status == 401) {
        throw new Error("401"); // auth credentionals failed , logout
    }
    return response.json();
}

export async function getToken(crypto: iAuth): Promise<any> {
    const tokenEndpoint = new URL(crypto.tokenUrl);
    tokenEndpoint.searchParams.append("grant_type", "authorization_code");
    tokenEndpoint.searchParams.append("client_id", crypto.clientId!);
    tokenEndpoint.searchParams.append("code_verifier", crypto.verifier);
    tokenEndpoint.searchParams.append("code", crypto.code);
    tokenEndpoint.searchParams.append("redirect_uri", window.location.origin + "/auth/callback");

    const hHeaders = new Headers();
    hHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    hHeaders.append("Accept", "application/json");
    var fetchOptions: any = {};
    fetchOptions.method = "POST";
    fetchOptions.headers = hHeaders;
    fetchOptions.body = tokenEndpoint.searchParams;

    try {
        const response = await fetch(crypto.tokenUrl, fetchOptions)
            .then(data => {
                if (data.status == 204) {
                    return "No Content";
                } else {
                    return data.json();
                }
            })
            .catch(err => {
                return err;
            });

        return response;
    } catch (err) {
        alert(err);
    }
}

export async function refreshIDPToken(): Promise<any> {
    try {
        const crypto = getLocalValue<iAuth>("auth");
        if (!crypto) throw new Error("Failed to refresh");
        const tokenEndpoint = new URL(crypto.tokenUrl);

        tokenEndpoint.searchParams.append("grant_type", "refresh_token");
        tokenEndpoint.searchParams.append("refresh_token", crypto.token.refresh_token);
        const hHeaders = new Headers();
        hHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        hHeaders.append("Accept", "application/json");
        var fetchOptions: any = {};
        fetchOptions.method = "POST";
        fetchOptions.headers = hHeaders;
        fetchOptions.body = tokenEndpoint.searchParams;

        let response = await fetch(crypto.tokenUrl, fetchOptions);
        if (response.status != 200) {
            throw new Error("error");
        }
        if (crypto !== null) {
            crypto.token = await response.json();
            saveLocalValue("auth", crypto);
        }
    } catch (err) {
        clearSession();
    }
}

export const clearSession = () => {
    sessionStorage.clear();
    localStorage.removeItem("auth"); // Remove tenant tokens as well.
    window.location.href = window.location.origin;
};

export const getRecentTenants = () => {
    const tenants = getLocalValue<iTenants>("RecentTenants");
    return tenants ? tenants.tenants : [];
};

export const saveRecentTenant = (tenant: iTenant) => {
    let tenants = getRecentTenants();
    if (tenants.find(t => t.key == tenant.key)) {
        tenants = tenants.filter(t => t.key != tenant.key);
    }
    tenants.unshift(tenant);
    saveLocalValue("RecentTenants", { tenants: tenants });
};

export const getTenantToken = (tenantName?: string): string | undefined => {
    const tenant = getSessionValue<iTenant>("tenant");
    return tenant?.token;
};

export const getActiveTenant = (returnToLower: boolean = true): string => {
    const tenant = getSessionValue<iTenant>("tenant");
    if (tenant) {
        return returnToLower ? tenant.key.toLowerCase() : tenant.key;
    }
    return "";
};

export const getActiveTenantName = (returnToLower: boolean = true): string => {
    const tenant = getSessionValue<iTenant>("tenant");
    if (tenant) {
        return returnToLower ? tenant.name.toLowerCase() : tenant.name;
    }
    return "";
};

export const isTenantValid = (tenant: string) => {
    if (getActiveTenant(true) == tenant.toLowerCase()) {
        return true;
    } else {
        return false;
    }
};

export const getSTSUrl = () => {
    let sURL = process.env.REACT_APP_STS;
    if (!sURL || sURL.length === 0) {
        var str = window.location;
        let stringtoReplaces = str.origin.substring(
            str.protocol.length + 2,
            str.origin.indexOf(".", str.protocol.length + 2),
        );
        sURL = str.origin.replace(stringtoReplaces, "sts");
    }
    if (!sURL.endsWith("/")) {
        sURL += "/";
    }

    return sURL;
};

export function parseJwt(token: string) {
    return JSON.parse(Buffer.from(token.split(".")[1], "base64").toString());
}
